import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class GaleriasService extends BaseService<any>{

  private static GALERIA_RESOURCE: string = "/galerias";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveGaleria(galeria: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let formData: FormData = new FormData();
    if (galeria.files != null) {
      for (let file of galeria.files) {
        formData.append("imagen", file, file.name);
      }
    }
    if(galeria.tag !== null){
      formData.append("tag", galeria.tag);
    }
    if (galeria.id == null) {
      this.post(BaseService.URL_BASE + GaleriasService.GALERIA_RESOURCE, formData, options, onSuccess);
    } else {
      formData.append("id", galeria.id);
      this.put(BaseService.URL_BASE + GaleriasService.GALERIA_RESOURCE, formData, options, onSuccess);
    }
  }

  public deleteGaleria(galeria: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + GaleriasService.GALERIA_RESOURCE + "/" + galeria.id, options, onSuccess);
  }

  public getGaleria(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + GaleriasService.GALERIA_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getGalerias(galeriaFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    if(galeriaFilter.tag != null){
      params.append("tag", galeriaFilter.tag.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + GaleriasService.GALERIA_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/galerias.service.ts